import React from 'react';
import Icon from '../ui/Icon';
import { IconProps } from '../ui/Icon/types';

export default function IconQuestionMark(props: IconProps) {
  return (
    <Icon {...props} width="18" height="17" viewBox="0 0 18 17" fill="none">
      <path
        d="M8.1665 13.5H9.83317V11.8333H8.1665V13.5ZM8.99984 0.166626C4.39984 0.166626 0.666504 3.89996 0.666504 8.49996C0.666504 13.1 4.39984 16.8333 8.99984 16.8333C13.5998 16.8333 17.3332 13.1 17.3332 8.49996C17.3332 3.89996 13.5998 0.166626 8.99984 0.166626ZM8.99984 15.1666C5.32484 15.1666 2.33317 12.175 2.33317 8.49996C2.33317 4.82496 5.32484 1.83329 8.99984 1.83329C12.6748 1.83329 15.6665 4.82496 15.6665 8.49996C15.6665 12.175 12.6748 15.1666 8.99984 15.1666ZM8.99984 3.49996C7.15817 3.49996 5.6665 4.99163 5.6665 6.83329H7.33317C7.33317 5.91663 8.08317 5.16663 8.99984 5.16663C9.9165 5.16663 10.6665 5.91663 10.6665 6.83329C10.6665 8.49996 8.1665 8.29163 8.1665 11H9.83317C9.83317 9.12496 12.3332 8.91663 12.3332 6.83329C12.3332 4.99163 10.8415 3.49996 8.99984 3.49996Z"
        fill="currentColor"
      ></path>
    </Icon>
  );
}
